import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos(filtro) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/projetos?datainicialetapa=${filtro.dataInicial}&datafinaletapa=${filtro.dataFinal}
                &tipocontratacao=${filtro.tipoContratacao}&natureza=${filtro.natureza}&modulo=${filtro.modulo}&codsolucao=${filtro.codSolucao}
            `)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(projetoId) {
        return axiosJwt
            .get(`${api}/sgtec/fornecedores/projetos/${projetoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterSolucoes(modulo) {
        return axiosJwt
        .get(`${api}/sgtec/fornecedores/projetos/solucoes/${modulo}`)
        .then(response => {
            return response.data
        }).catch(error => {
            return errorHandler(error)
        })
    }
}
